import React, { type ComponentProps } from 'react';
import { StyleSheet } from 'react-native';

import { theme } from '@garnish/constants';
import { BodyText } from '@garnish/core';

// ─────────────────────────────────────────────────────────────────────────────

export const ScreenHeaderTitle = (props: Props) => {
  const { children, style, ...restProps } = props;

  return (
    <BodyText
      bold
      maxFontSizeMultiplier={1.2}
      numberOfLines={1}
      sizeMatch={['24']}
      style={[styles.title, style]}
      {...restProps}
    >
      {children}
    </BodyText>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  title: {
    flexShrink: 1,
    color: theme.colors.WHITE,
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = ComponentProps<typeof BodyText>;
